import {
    BRANDED_EGIFT,
    CARD_LINK,
    CHANGE_BRAND,
    EDIT_SAVED_CARDS,
    PLASTIC_REDEMPTION,
    UNBRANDED_TO_EGIFT,
    UNBRANDED_TO_LINK,
    UNENROLL_CARD_FROM_LINK,
} from '@/src/modules/pg-plus/constants'
import { IRedeemState, ModalAndStepActions } from '@/src/common/reducers/types'
import {
    DISPATCH_CARD_LINK_MODAL,
    DISPATCH_CHANGE_BRAND_MODAL,
    DISPATCH_EDIT_SAVED_CARDS_MODAL,
    DISPATCH_HIDE_MODAL,
    DISPATCH_REDEEM_EGIFT_MODAL,
    DISPATCH_REDEEM_PLASTIC_MODAL,
    DISPATCH_SET_GIFT_STATE,
    DISPATCH_SET_STEP,
    DISPATCH_STONLY_MODAL,
    DISPATCH_UNBRANDED_TO_EGIFT,
    DISPATCH_UNBRANDED_TO_LINK,
    DISPATCH_UNENROLL_MODAL,
} from '@/src/common/reducers/constants'

export function PGPlusStepAndModalReducer(
    state: IRedeemState,
    action: ModalAndStepActions
) {
    const { type } = action

    switch (type) {
        case DISPATCH_HIDE_MODAL:
            return {
                ...state,
                showModal: false,
                modalName: '',
            }
        case DISPATCH_SET_STEP:
            return {
                ...state,
                stepName: action?.payload?.stepName ?? '',
                headerText: action?.payload?.headerText ?? '',
                showModal: action?.payload?.showModal ?? false,
                modalName: action?.payload?.modalName ?? state?.modalName,
                redemptionSelection:
                    action?.payload?.redemptionSelection ??
                    state?.redemptionSelection,
            }
        case DISPATCH_CHANGE_BRAND_MODAL:
            return {
                ...state,
                modalName: CHANGE_BRAND,
                showModal: true,
                redemptionSelection: CHANGE_BRAND,
            }
        case DISPATCH_REDEEM_PLASTIC_MODAL:
            return {
                ...state,
                modalName: PLASTIC_REDEMPTION,
                showModal: true,
                redemptionSelection: PLASTIC_REDEMPTION,
            }
        case DISPATCH_CARD_LINK_MODAL:
            return {
                ...state,
                modalName: CARD_LINK,
                showModal: true,
                redemptionSelection: CARD_LINK,
            }
        case DISPATCH_REDEEM_EGIFT_MODAL:
            return {
                ...state,
                modalName: BRANDED_EGIFT,
                showModal: true,
                redemptionSelection: BRANDED_EGIFT,
            }
        case DISPATCH_UNENROLL_MODAL: {
            return {
                ...state,
                modalName: UNENROLL_CARD_FROM_LINK,
                showModal: true,
                redemptionSelection: CARD_LINK,
            }
        }
        case DISPATCH_EDIT_SAVED_CARDS_MODAL: {
            return {
                ...state,
                modalName: EDIT_SAVED_CARDS,
                showModal: true,
                redemptionSelection: CARD_LINK,
            }
        }
        case DISPATCH_UNBRANDED_TO_LINK: {
            return {
                ...state,
                modalName: DISPATCH_UNBRANDED_TO_LINK,
                showModal: true,
                redemptionSelection: UNBRANDED_TO_LINK,
            }
        }
        case DISPATCH_UNBRANDED_TO_EGIFT:
            return {
                ...state,
                modalName: DISPATCH_UNBRANDED_TO_EGIFT,
                showModal: true,
                redemptionSelection: UNBRANDED_TO_EGIFT,
            }
        case DISPATCH_STONLY_MODAL: {
            return {
                ...state,
                modalName: DISPATCH_STONLY_MODAL,
                showModal: true,
            }
        }
        case DISPATCH_SET_GIFT_STATE:
            return {
                ...state,
                cardUuid: action?.payload?.cardUuid ?? '',
                brand: action?.payload?.brand ?? '',
                brandSlug: action?.payload?.brandSlug ?? '',
                denomination: action?.payload?.denomination ?? 0,
                refetchGift: action?.payload?.refetchGift ?? null,
                isPgPlus: action?.payload?.isPgPlus ?? false,
                is24HoursOld:
                    action?.payload?.is24HoursOld ?? state?.is24HoursOld,
                createdAt: action?.payload?.createdAt ?? state?.createdAt,
            }
        default:
            return state
    }
}
